import React, {useCallback, useState, useEffect} from 'react';
import {Card, Page, Layout, Spinner} from '@shopify/polaris';
import createApp from '@shopify/app-bridge';
import {Redirect} from '@shopify/app-bridge/actions';
import {getSessionToken} from "@shopify/app-bridge-utils";

function Price() {
    const [subscription, setSubscription] = useState(null);
    const [confirmShopSettings, setConfirmShopSettings] = useState(false);

    const [pageJustLoadedShopSettings, setPageJustLoadedShopSettings] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState(false);

    useEffect(() => {
        fetchSubscription();
    }, []);

    const fetchSubscription = async () => {
        window['bridge-app'] = createApp({
            apiKey: window['apiKey'],
            host: window['host']
        });

        const sessionToken = await getSessionToken(window['bridge-app']);

        if (sessionToken) {
            const settings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionToken
                }
            };
            let queryParams = window.$queryString;
            queryParams += '&load_currency_format=true';
            const response = await fetch('https://hide-price.webpanda-solutions.com/api/subscription/current/' + queryParams, settings);
            // if user session expired reload the page
            if (response.status === 403) {
                window.location.reload();
                return false;
            }

            const responseJson = await response.json();

            if (response.status === 274) {
                window.location.href = 'https://hide-price.webpanda-solutions.com/login/' + window.$queryString;
                return false;
            }
            if (response.status === 275) {
                const redirect = Redirect.create(window['bridge-app']);
                redirect.dispatch(Redirect.Action.REMOTE, responseJson.redirect_url);
                return false;
            }

            setSubscription(responseJson);
        }
    };

    const handleShopSettingsSubmit = () => {
        setPageJustLoadedShopSettings(false);

        if (
            confirmShopSettings
        ) {
            setSubmitLoading(true);
            getSessionToken(window['bridge-app'])
                .then((sessionToken) => {
                    fetch(`https://hide-price.webpanda-solutions.com/api/subscription/shopsettings/${window.$queryString}`, {
                        method: 'POST',
                        body: JSON.stringify({'shop_settings': 1}),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionToken
                        }
                    }).then(response => {
                        if (response.status === 200) {
                            /*setSubmitSuccess(true);
                            setCurrencyConfigured(true);
                            window.scrollTo(0, 0);*/
                            window.location.reload();
                            return false;
                        } else if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }  else {
                            setSubmitError(true);
                        }
                        return response.json();
                    }).then(response => {
                        setSubmitLoading(false);
                    }).catch(err => {
                        setSubmitError(true);
                        setSubmitLoading(false);
                    });
                })
                .catch((err) => console.log(err));
        }
    };

    const handleConfirmShopSettingsChange = useCallback((value) => {
        setConfirmShopSettings(value);
    }, []);

    const toggleSubmitSuccess = useCallback(() => {
        setSubmitSuccess(false);
    }, []);

    return (
        <Page>
            <Layout>
                <Layout.Section>
                {
                    subscription ?
                        <Card title="Shop Setup" sectioned>
                            <div style={{fontSize: '1.1em'}}>
                                <p>Before using the app, you need to edit your store's currency format to make the app
                                    work properly on your store.</p>
                                <br/>
                                <p>1. Select <strong>Settings</strong> from the bottom left area of your Shopify Admin:
                                </p>
                                <br/>
                                <img className="store-setup-image"
                                     src="https://hide-price.webpanda-solutions.com/media/step1.png" alt="Step 1"/>
                                <br/>
                                <br/>
                                <p>2. In <strong>Store currency</strong> section, select <strong>Change
                                    formatting</strong>:</p>
                                <br/>
                                <img className="store-setup-image"
                                     src="https://hide-price.webpanda-solutions.com/media/step3.png" alt="Step 3"/>
                                <br/>
                                <br/>
                                <p>3. Replace the <strong>HTML with currency</strong> input with the code below:</p>
                                <pre>
                                    <code>{subscription.money_with_currency_format}</code>
                                </pre>
                                <p>4. Replace the <strong>HTML without currency</strong> input with the code below:</p>
                                <pre>
                                    <code>{subscription.money_format}</code>
                                </pre>
                                <br/>
                                <img className="store-setup-image"
                                     src="https://hide-price.webpanda-solutions.com/media/step4-5.png" alt="Step 4"/>
                                <br/>
                                <br/>
                                <p>5. Click <strong>Save</strong> to apply your settings:</p>
                                <br/>
                                <img className="store-setup-image"
                                     src="https://hide-price.webpanda-solutions.com/media/step6.png" alt="Step 6"/>
                                <br/>
                                <br/>
                                <p style={{'color': 'orange'}}>If you uninstall the app you should reverse these changes
                                    and set the fields to the initial value.</p>
                                <p style={{'color': 'orange'}}>But even if you don't it won't affect the shop in any
                                    way.</p>
                                <br/>
                                {/*<Form autoComplete={false} onSubmit={handleShopSettingsSubmit}>
                                    <Frame>
                                        <div className="shop-setup-confirm">
                                            <Checkbox
                                                label="Confirm you have updated the Currency Shop Settings"
                                                checked={confirmShopSettings}
                                                onChange={handleConfirmShopSettingsChange}
                                                error={(confirmShopSettings || pageJustLoadedShopSettings) ? null : "You need to confirm the Shop Settings are done to be able to continue"}
                                            />
                                            {
                                                submitLoading ?
                                                    <div className="main-button-wrapper">
                                                        <Button submit primary loading>Continue to App ></Button>
                                                    </div>
                                                    :
                                                    <div className="main-button-wrapper">
                                                        <Button submit primary>Continue to App ></Button>
                                                    </div>
                                            }
                                            {
                                                submitSuccess ?
                                                    <Toast content="Settings Saved" onDismiss={toggleSubmitSuccess} />
                                                    :
                                                    null
                                            }
                                        </div>
                                    </Frame>
                                </Form>*/}
                            </div>
                        </Card>
                        :
                        <Card sectioned>
                            <Spinner accessibilityLabel="Spinner example" size="large" color="teal"/>
                        </Card>
                }
                </Layout.Section>
            </Layout>
        </Page>
    );
}

export default Price;
